import {createApp} from 'vue';
import LoginModal from '../../components/LoginModal.vue';

document.addEventListener('DOMContentLoaded', () => {
    const userArea = document.querySelector('.user-area[data-login-config]');
    if (!userArea) {
        return;
    }

    const config = JSON.parse(userArea.getAttribute('data-login-config'));
    const el = document.createElement('div');
    document.body.appendChild(el);
    createApp(LoginModal, {config}).mount(el);

    for (const button of document.querySelectorAll('.open-login-modal')) {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            window.openLoginModal({view: button.dataset.view || 'login'});
        });
    }

    const params = new URLSearchParams(window.location.search);
    if (params.has('login')) {
        const autoOpen = () => {
            if (!window.customerAuth?.isAuthenticated) {
                window.openLoginModal({
                    socialError: params.has('social_error'),
                    linkExpired: params.has('link_expired'),
                });
            }
        };
        if (window.customerAuth) {
            autoOpen();
        } else {
            document.addEventListener('customerAuthLoaded', autoOpen, {once: true});
        }
    }
});
